import { UpdateUserResponse } from '../../../../../../types/api/endpoints/auth/update.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { ProfileAccountFormCOMSchema } from './ProfileAccountFormCOM.types';

const PREFIX = '[updateUserCOMQuery]';

export const UPDATE_USER_QUERY_KEY = 'UPDATE_USER';

export const updateUserCOMQuery = async (data: ProfileAccountFormCOMSchema) => {
  console.log(PREFIX, `Requesting user account update...`);
  const response = await AUTH_ENDPOINTS.updateCOM(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account update response.`);
  return json as UpdateUserResponse;
};
